import axios from 'axios';
import { message } from 'antd';

let refreshFlag = false;
// create an axios instance
const service = axios.create({
  // eslint-disable-next-line no-undef
  baseURL: process.env.REACT_APP_PYTHON_API_URL,
  // baseURL: 'http://consumer_processing.frp.pizelife.com/api',
  // baseURL: '/api1',
  timeout: 0 // 不限制超时，因为有些接口等待时间会很长
});

// request interceptor
service.interceptors.request.use(config => {
  let token = sessionStorage.getItem('jwt-access-token');
  if (token) {
    config.headers['Authorization'] = 'Bearer ' + token;
  }
  // config.headers['Authorization'] = 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpYXQiOjE3NDA0Nzg0OTQsIm5iZiI6MTc0MDQ3ODQ5NCwianRpIjoiNWVlZGQyMDYtM2QzZi00NDgyLTllMmMtYTAwNjQwOWE2Nzc1IiwiaWRlbnRpdHkiOjEsImZyZXNoIjpmYWxzZSwidHlwZSI6ImFjY2VzcyIsInVzZXJfY2xhaW1zIjp7InVzZXJJZCI6bnVsbCwidXNlck5hbWUiOm51bGwsImVtYWlsSWQiOiJnZW9yZ2UucGFuQHVuaWxldmVyLmNvbSIsImRlcGFydG1lbnQiOiJOdXRyaXRpb24iLCJyb2xlIjoiQWRtaW4iLCJwZXJtaXNzaW9ucyI6WyJBRE1JTklTVEVSIiwiVFJFTkRfVklFV0VSIiwiVFJFTkRfQURNSU4iLCJJREVBVEVTVF9WSUVXRVIiLCJJREVBVEVTVF9BRE1JTiIsIkJVX0ZFRURCQUNLX1ZJRVdFUiIsIk9DQ0FTSU9OX1ZJRVdFUiIsIkdPVEZMX1dFRU5BX1ZJRVdFUiIsIkdPVEZMX1dFRU5BX0FETUlOIl0sImNhdGVnb3JpZXMiOlsiTlVUIl19LCJpc3MiOiJOdXRyaXRpb24gRGlnaXRhbCBFY29zeXN0ZW0gLSBsb2NhbCJ9.WuLbBNUGwvT6DpOPSXmyP2IUJT2sRk3TjQkHtTyWtlE';
  if (!config.headers['Content-Type']) {
    config.headers['Content-Type'] = 'application/json';
  }
  return config;
}, error => {
  return Promise.reject(error);
});

// response interceptor
service.interceptors.response.use(
  response => {
    if (response.status !== 200) {
      const res = response.data;
      message.error(res.message);
      return Promise.reject(res);
    }
    if (response.config.originData) {
      return response;
    }
    return response.data;
  },
  error => {
    if (error.code === 'ERR_NETWORK') {
      message.error(error.message);
    }
    else if (error.response.status === 401) {
      if (refreshFlag) {
        return Promise.reject(error);
      }
      refreshFlag = true;
      sessionStorage.removeItem('jwt-access-token');
      setTimeout(() => {
        window.location.reload();
      }, 3000);
    }
    else if (error.response && error.response.status === 500) {
      error.response.data.message && message.error(error.response.data.message);
    } else if (error.response && error.response.status === 400) {
      error.response.data.message && message.error(error.response.data.data);
    }
    return Promise.reject(error);
  });

export default service;
